import { Box, Typography, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const NoteBox = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  width: '100%',
}));

export const NoteLabel = styled(Typography)({});

export const NotePlaceholder = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  cursor: 'text',
  whiteSpace: 'pre-wrap',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.85rem',
  },
}));

export const StyledNoteTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: 'transparent',
  borderRadius: theme.spacing(1),
  width: '100%',
  '& .MuiInputBase-root': {
    padding: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  '& .MuiInputBase-input': {
    color: theme.palette.text.primary,
  },
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.text.primary,
    opacity: 0.4,
  },
  '& .MuiFilledInput-root': {
    backgroundColor: theme.palette.background.secondary,
  },
  '& .MuiFilledInput-underline:before': {
    borderBottom: 'none',
  },
  '& .MuiFilledInput-underline:after': {
    borderBottom: 'none',
  },
}));
